import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';

import Slide from '@material-ui/core/Slide';
import CloseIcon from '@material-ui/icons/Close';
import { makeStyles } from '@material-ui/core';
import TableModal from './TableModal';
import ExportButton from '../ExportButton';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide ref={ref} direction="up" {...props} />;
});

const useStyles = makeStyles((theme) => ({
  container: {
    backdropFilter: 'blur(5px)'
  },
  header: {
    padding: 30,
    borderTop: '5px solid #2DB9C4'
  },
  paper: {
    padding: 30
  },
  export: {
    fontFamily: 'PT sans',
    fontSize: '16px',
    textTransform: 'lowercase',
    fontWeight: 'bold',
    borderColor: '#002380',
    borderRadius: 0,
    marginRight: '1rem',
    minWidth: '145px',
    margin: '30px 0'
  },
  closeButtonContainer: {
    textAlign: 'right',
    margin: '20px 0'
  },
  closeButton: {
    fontSize: '30px',
    cursor: 'pointer'
  },
  exportButtonContainer: {
    margin: '30px 0'
  }
}));

const PeerOperatingModal = ({ open, onClose }) => {
  const classes = useStyles();
  return (
    <div>
      <Dialog
        aria-describedby="alert-dialog-slide-description"
        aria-labelledby="alert-dialog-slide-title"
        classes={{ paper: classes.paper, container: classes.container }}
        keepMounted
        maxWidth={false}
        onClose={onClose}
        open={open}
        TransitionComponent={Transition}>
        {/* Header */}
        <div className={classes.closeButtonContainer}>
          <CloseIcon className={classes.closeButton} onClick={onClose} />
        </div>
        <TableModal />

        <DialogActions>
          <div className={classes.exportButtonContainer}>
            <ExportButton />
          </div>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default PeerOperatingModal;
